"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagsList = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var TagsList_st_css_1 = require("./TagsList.st.css");
var filter_data_props_1 = require("../../utils/filter-data-props");
var utils_1 = require("../../utils");
exports.TagsList = function (_a) {
    if (_a === void 0) { _a = {}; }
    var children = _a.children, className = _a.className, _b = _a.onChange, onChange = _b === void 0 ? utils_1.noop : _b, rest = tslib_1.__rest(_a, ["children", "className", "onChange"]);
    return (React.createElement("div", tslib_1.__assign({ className: TagsList_st_css_1.st(TagsList_st_css_1.classes.root, className) }, filter_data_props_1.filterDataProps(rest), { "data-hook": "tags-list" /* TagsList */, onChange: onChange, role: "group" }, rest), React.Children.map(children, function (child, tagIndex) {
        return React.cloneElement(child, { tagIndex: tagIndex });
    })));
};
exports.TagsList.displayName = "TagsList" /* TagsList */;
exports.TagsList.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onChange: PropTypes.func,
};
//# sourceMappingURL=TagsList.js.map